import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const StyledFooter = styled.div`
  display: grid;
  padding: 5rem 0 0.5rem;
  color: white;
  background: ${t => t.theme.blue};
  margin-top: 1.5rem;
  
  a {
    color: inherit;
    text-decoration: none;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  @media (min-width: ${t => t.theme.desktopBreakpoint}) {
    grid-template-columns: 1fr repeat(12, #{${t => t.theme.desktopBreakpoint}/12}) 1fr;

    ul {
      grid-column: 2/14;
    }
  }
`;

function Footer() {
  return (
    <StyledFooter>
      <ul>
        <li>
          <NavLink to="/" exact activeClassName="active">
            Home
          </NavLink>
        </li>
      </ul>
    </StyledFooter>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx